<template>
  <div class="m-common__review__links" id="base-review-evaluations">
    <ul>
      <li>
        <a :href="reviewDetailUrl" v-if="isLinkToDetail"><span class="num lsf-icon notify" id="reviewComment">{{ countComment }}</span>件のコメント</a>
        <span v-else><span class="num lsf-icon notify" id="reviewComment">{{ countComment }}</span>件のコメント</span>
      </li>
      <li>
        <a :href="reviewDetailUrl" v-if="isLinkToDetail"><span class="num lsf-icon good" id="reviewAvail">{{ countHelpful }}</span>人が役に立ったと考えています</a>
        <span v-else><span class="num lsf-icon good" id="reviewAvail">{{ countHelpful }}</span>人が役に立ったと考えています</span>
      </li>
    </ul>
  </div>
</template>

<script>
import urls from '@/mixins/urls'
export default {
  name: 'BaseReviewEvaluations',
  mixins: [ urls ],
  props: {
    reviewId: {
      type: Number,
      required: true
    },
    countHelpful: {
      type: Number,
      default: 0
    },
    countComment: {
      type: Number,
      default: 0
    },
    isLinkToDetail: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    reviewDetailUrl () {
      const query = this.$store.state.storeReviews.query
      return this.getReviewDetailUrl(this.reviewId, query)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BaseReviewEvaluations.vue